<template>
    <div class="cbg-content">
        <img src="../../assets/template3/center-bg.png" alt="" class="map-center">
        <img src="../../assets/template3/map-bg.png" alt="" class="map-bg">
        <img src="../../assets/template3/left-icon.png" alt="" class="left-icon">
        <img src="../../assets/template3/right-icon.png" alt="" class="right-icon">
        <div class="point-item" v-for="(item, i) in pointlist" :key="i"
            :style="{ left: item.left + 'px', top: item.top + 'px' }">
            <img :src="pointicon" alt="" :title="item.title" @click="showlog(item)">
        </div>
        <div class="center-dialog"
            :style="{ left: logitem.left + 'px', top: logitem.top + 'px', opacity: showdialog ? 1 : 0, 'z-index': showdialog ? 401 : -1}">
            <img :src="dialogcontent" alt="">
            <div class="close-content" @click="closedialog"></div>
        </div>
    </div>
</template>

<script>
import pointicon from '@/assets/template3/point-icon.png'
import dialogcontent from '@/assets/template3/tem3-dialog.png'

export default {
    name: 'template.centerbg',
    data() {
        return {
            pointicon,
            dialogcontent,
            pointlist: [
                { left: 210, top: 205, title: '大营镇', content: '第一行\n第二行' },
                { left: 467, top: 455, title: '杨庄镇', content: '第一行\n第二行' },
                { left: 443, top: 285, title: '商酒务镇', content: '第一行\n第二行' },
                { left: 600, top: 300, title: '12345', content: '第一行\n第二行' },
            ],
            showdialog: false,
            logitem: {
                left: 198,
                top: 285
            }
        }
    },
    methods: {
        showlog(item) {
            console.log("showlog");
            this.showdialog = true
        },
        closedialog() {
            this.showdialog = false
        }
    }
}
</script>

<style scoped lang="scss">
.cbg-content {
    height: 921px;
    position: absolute;
    top: -60px;
    left: 25px;
    display: flex;

    .map-center {
        width: 919px;
        height: 921px;
        position: absolute;
        animation: 25s rotate1 linear infinite;
        z-index: -1;
    }

    @keyframes rotate1 {
        from {
            transform: rotate(0);
        }

        to {
            transform: rotate(360deg);
        }
    }

    .map-bg {
        width: 712px;
        height: 580px;
        margin: auto;
    }

    .left-icon {
        position: absolute;
        width: 46px;
        height: 37px;
        left: 0;
        top: calc(50% - 18px);
        animation: leftani 3s infinite;
    }

    .right-icon {
        position: absolute;
        width: 46px;
        height: 37px;
        right: -8px;
        top: calc(50% - 18px);
        animation: rightani 3s infinite;
    }

    @keyframes leftani {
        0% {
            transform: translateX(0px);
        }

        50% {
            transform: translateX(-10px);
        }

        100% {
            transform: translateX(0);
        }
    }

    @keyframes rightani {
        0% {
            transform: translateX(0px);
        }

        50% {
            transform: translateX(10px);
        }

        100% {
            transform: translateX(0);
        }
    }

    .point-item {
        position: absolute;
        width: 45px;
        height: 54px;
        opacity: 0.5;
        animation: 1s light infinite;
        cursor: pointer;

        img {
            width: 45px;
            height: 54px;
        }
    }

    @keyframes light {
        0% {
            opacity: 0.5;
        }

        50% {
            opacity: 1;
        }

        100% {
            opacity: 0.5;
        }
    }

    .center-dialog {
        position: absolute;
        width: 566px;
        height: 325px;
        z-index: 401;
        transition: all 1s;

        img {
            width: 100%;
            height: 100%;
        }
    }

    .close-content {
        width: 25px;
        height: 25px;
        position: absolute;
        right: 19px;
        top: 14px;
        cursor: pointer;
    }
}
</style>